import { ResponseInventoryControlRegistry } from "api/generated";
import {
  getRowClassNameByPeriod,
  getStockControlByPeriodColumns,
} from "./StockControlColumns";
import { Fragment, useState } from "react";
import { useIsMobile } from "hooks/useIsMobile";
import { Table } from "antd";
import moment from "moment";
import StockDifferenceViewer from "./StockDifferenceViewer";
import { UsePaginationTableReturn } from "hooks/commons/usePaginationTable";
import { ResponsiveTable } from "common/components/table/ResponsiveTable";

interface StockControlTableByPeriodProps {
  pagination: UsePaginationTableReturn<ResponseInventoryControlRegistry>;

  loading: boolean;
  recalculatePeriod: (dateToReCalculate: moment.Moment) => void;
  onRegisterManualMeasurement?: (dateToReCalculate: moment.Moment) => void;
}

function StockControlTableByPeriod({
  pagination,
  loading,

  recalculatePeriod,
  onRegisterManualMeasurement,
}: StockControlTableByPeriodProps) {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const { isMobile } = useIsMobile();
  const [periodRecord, setPeriodRecord] =
    useState<ResponseInventoryControlRegistry>();
  const columnActions = {
    onRecalculatePeriod: (record: ResponseInventoryControlRegistry) => {
      recalculatePeriod(moment(record.registeredDate));
    },
    onViewDetails: (record: ResponseInventoryControlRegistry) => {
      setPeriodRecord(record);
      setIsDetailsOpen(true);
    },
    onRegisterManualMeasurement: (record: ResponseInventoryControlRegistry) => {
      onRegisterManualMeasurement?.(moment(record.registeredDate));
    },
    showRegenerate: true,
    isMobile,
  };
  const columns = getStockControlByPeriodColumns(columnActions);

  function onClose() {
    setIsDetailsOpen(false);
    setPeriodRecord(undefined);
  }
  return (
    <Fragment>
      <ResponsiveTable<ResponseInventoryControlRegistry>
        columns={columns}
        style={{ width: "100%" }}
        rowKey={(row, idx) => `${row.registeredDate}_${idx || idx}`}
        dataSource={pagination.items}
        scroll={{
          x: isMobile ? undefined : "max-content",
          y: "calc(100vh - 450px)",
        }}
        loading={loading}
        rowClassName={getRowClassNameByPeriod}
        pagination={{
          ...pagination.paginationConfig,
          onChange: pagination.onPageChange,
          onShowSizeChange: pagination.onPageSizeChange,
        }}
      />

      <StockDifferenceViewer
        periodRecord={periodRecord}
        onClose={onClose}
        isDetailsOpen={isDetailsOpen}
      />
    </Fragment>
  );
}

export default StockControlTableByPeriod;
